import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  FiList, FiFolder, FiGitBranch, FiGrid, FiLayers,
  FiShield, FiCpu, FiZap, FiTrendingUp, FiBriefcase,
  FiActivity, FiBox, FiTarget, FiServer
} from 'react-icons/fi';
import { useSolution } from '../../context/SolutionContext';
import DendrographView from './views/DendrographView';
import ListView from './views/ListView';
import FolderView from './views/FolderView';
import MatrixView from './views/MatrixView';
import SummaryView from './views/SummaryView';
import ValidationView from './views/ValidationView';
import AutoArchitectView from './views/AutoArchitectView';
import TraceabilityView from './views/TraceabilityView';
import TransformationView from './views/TransformationView';
import WBSView from './views/WBSView';
import AlternativeSolutionsView from './views/AlternativeSolutionsView';
import ApproachTraceabilityView from './views/ApproachTraceabilityView';
import ArchitectureDiagram from '../visualization/ArchitectureDiagram';
import FunctionalView from './views/FunctionalView';
import ImplementationView from './views/ImplementationView';
import BOMView from './views/BOMView';
import DevOpsView from './views/DevOpsView';
import AIParadigmView from './views/AIParadigmView';
import ComponentDetail from '../selector/ComponentDetail';
import PDFExport from '../export/PDFExport';

// ==================== VIEWS MAP ====================
const VIEW_COMPONENTS = {
  'auto': AutoArchitectView,
  'alternatives': AlternativeSolutionsView,
  'paradigms': AIParadigmView,
  'summary': SummaryView,
  'list': ListView,
  'folder': FolderView,
  'dendrograph': DendrographView,
  'architecture': ArchitectureDiagram,
  'matrix': MatrixView,
  'traceability': TraceabilityView,
  'approaches': ApproachTraceabilityView,
  'validation': ValidationView,
  'functional': FunctionalView,
  'implementation': ImplementationView,
  'bom': BOMView,
  'transformation': TransformationView,
  'wbs': WBSView,
  'devops': DevOpsView,
};

const MainPanel = ({ activeView, setActiveView }) => {
  const { state } = useSolution();
  
  const ActiveViewComponent = VIEW_COMPONENTS[activeView] || AutoArchitectView;
  
  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="flex-1 bg-white overflow-hidden flex flex-col"
    >
      {/* Active View */}
      <div className="flex-1 overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeView}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="h-full"
          >
            <ActiveViewComponent />
          </motion.div>
        </AnimatePresence>
      </div>
      
      {/* Modals */}
      <ComponentDetail />
      <PDFExport />
    </motion.main>
  );
};

export default MainPanel;